<script setup lang="ts">
import {ref} from "vue";
import {Button, Popover} from "@/Components/Library";
import type {Tag} from "@/Types";

type Props = {
    tags: Array<Tag>;
    overflow?: number;
    center?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
    tags: () => [],
    overflow: 3,
    center: false,
});

const tagsPopover = ref<Popover>();
</script>
<template>
    <div class="flex flex-wrap" :class="{'justify-center': center}" v-if="tags?.length">
        <span
            v-for="tag in tags.slice(0, overflow)"
            class="my-1 mr-1 rounded-full border border-askr-green bg-transparent px-2 py-1 text-center text-xs leading-none text-askr-green"
        >
            {{ tag.name }}
        </span>
        <Button
            v-if="tags.length > overflow"
            :icon="{icon: overflow ? 'fe:elipsis-h' : 'fa:tags'}"
            @click="tagsPopover?.toggle"
        />
        <Popover ref="tagsPopover" class="relative flex items-center justify-center !border border-stone-200 shadow-lg">
            <div class="flex flex-wrap gap-2">
                <span
                    v-for="tag in tags"
                    class="my-1 mr-1 rounded-full border border-askr-green bg-transparent px-2 py-1 text-center text-xs leading-none text-askr-green"
                >
                    {{ tag.name }}
                </span>
            </div>
        </Popover>
    </div>
</template>
<style scoped></style>
